angular.module('app')
  .factory('$dialog', function ($uibModal, $document) {
    function parentElem(parentSelector) {
      return parentSelector ? angular.element($document[0].querySelector(parentSelector)) : undefined;
    }

    function alert(title, body, options, parentSelector) {
      return $uibModal.open({
        animation: true,
        // ariaLabelledBy: 'modal-title',
        // ariaDescribedBy: 'modal-body',
        templateUrl: 'dialog-modal/alert-modal.html',
        appendTo: parentElem(parentSelector),
        controller: ['$scope', ($scope) => {
          $scope.title = title;
          $scope.body = body;
          $scope.options = options || {};
        }],
        windowClass: `dialog ${options.windowClass || 'info'}`,
      });
    }

    function confirm(title, body, options, parentSelector) {
      return $uibModal.open({
        animation: true,
        templateUrl: 'dialog-modal/confirm-modal.html',
        appendTo: parentElem(parentSelector),
        controller: ['$scope', ($scope) => {
          $scope.title = title;
          $scope.body = body;
          $scope.options = options || {};
        }],
        windowClass: `dialog ${options.windowClass || 'primary'}`,
      });
    }

    function prompt(title, label, value, required, placeholder, options, parentSelector) {
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'dialog-modal/prompt-modal.html',
        appendTo: parentElem(parentSelector),
        controller: ['$scope', '$uibModalInstance', ($scope, $uibModalInstance) => {
          $scope.title = title;
          $scope.label = label;
          $scope.value = value;
          $scope.required = required;
          $scope.placeholder = placeholder;
          $scope.options = options || {};

          $scope.submit = () => {
            if (!$scope.form.$invalid) {
              $uibModalInstance.close($scope.value);
            }
          };
        }],
        windowClass: `dialog ${options.windowClass || ''}`,
      });
    }

    function promptText(title, label, value, required, placeholder, options, parentSelector) {
      return $uibModal.open({
        animation: true,
        backdrop: 'static',
        templateUrl: 'dialog-modal/prompt-text-modal.html',
        appendTo: parentElem(parentSelector),
        controller: ['$scope', '$uibModalInstance', ($scope, $uibModalInstance) => {
          $scope.title = title;
          $scope.label = label;
          $scope.value = value;
          $scope.required = required;
          $scope.placeholder = placeholder;
          $scope.options = options || {};

          $scope.submit = () => {
            if (!$scope.form.$invalid) {
              $uibModalInstance.close($scope.value);
            }
          };
        }],
        windowClass: `dialog ${options.windowClass || ''}`,
      });
    }

    function error(msg) {
      return alert('Error', `<p>${msg}</p>`, { windowClass: 'danger', closeBtnClass: 'btn-danger' });
    }

    function success(msg) {
      return alert('Success', `<p>${msg}</p>`, { windowClass: 'success', closeBtnClass: 'btn-success' });
    }

    function onError(response) {
      let msg = 'Whoops, looks like something went wrong.';

      if (response && response.status === 422 && response.data && response.data.errors) {
        [[msg]] = Object.values(response.data.errors);
      }

      return error(msg);
    }

    return {
      alert,
      confirm,
      prompt,
      promptText,
      error,
      success,
      onError,
    };
  })

  .run(['$templateCache', function ($templateCache) {
    $templateCache.put('dialog-modal/alert-modal.html', `
      <div class="modal-header">
        <h5 class="modal-title">{{ title || '&nbsp;' }}</h5>
        <button type="button" class="close" ng-click="$dismiss()" data-dismiss="modal" aria-label="Close" tabindex="-1">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" ng-bind-html="body | unsafe"></div>
      <div class="modal-footer">
        <button type="button" class="btn" ng-click="$dismiss()" data-dismiss="modal" ng-class="options.closeBtnClass || 'btn-primary'">
          {{ options.closeBtnText || 'Close' }}
        </button>
      </div>
    `);

    $templateCache.put('dialog-modal/confirm-modal.html', `
      <div class="modal-header">
        <h5 class="modal-title">{{ title || '&nbsp;' }}</h5>
        <button type="button" class="close" ng-click="$dismiss()" data-dismiss="modal" aria-label="Close" tabindex="-1">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body" ng-bind-html="body | unsafe"></div>
      <div class="modal-footer">
        <button type="button" class="btn" ng-click="$dismiss()" data-dismiss="modal" ng-class="options.cancelBtnClass || 'btn-outline-primary'">
          {{ options.cancelBtnText || 'Cancel' }}
        </button><!-- do not delete --><button type="button" class="btn" ng-click="$close()" ng-class="options.okBtnClass || 'btn-primary'">
          {{ options.okBtnText || 'OK' }}
        </button>
      </div>
    `);

    $templateCache.put('dialog-modal/prompt-modal.html', `
      <form name="form" ng-submit="submit()" novalidate autocomplete="off">
        <div class="modal-header">
          <h5 class="modal-title">{{ title || '&nbsp;' }}</h5>
          <button type="button" class="close" ng-click="$dismiss()" data-dismiss="modal" aria-label="Close" tabindex="-1">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <label ng-if="label">{{ label }} <span class="required" ng-show="required">*</span></label>
          <input type="text" name="value" class="form-control" ng-model="value" ng-required="required" placeholder="{{ placeholder || '' }}">
          <div ng-messages="form.value.$error" ng-if="form.$submitted">
            <div ng-message="required">This field is required</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" ng-click="$dismiss()" data-dismiss="modal" ng-class="options.cancelBtnClass || 'btn-outline-primary'">
            {{ options.cancelBtnText || 'Cancel' }}
          </button><!-- do not delete --><button type="submit" class="btn" ng-class="options.okBtnClass || 'btn-primary'">
            {{ options.okBtnText || 'OK' }}
          </button>
        </div>
      </form>
   `);

    $templateCache.put('dialog-modal/prompt-text-modal.html', `
      <form name="form" ng-submit="submit()" novalidate autocomplete="off">
        <div class="modal-header">
          <h5 class="modal-title">{{ title || '&nbsp;' }}</h5>
          <button type="button" class="close" ng-click="$dismiss()" data-dismiss="modal" aria-label="Close" tabindex="-1">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <label ng-if="label">{{ label }} <span class="required" ng-show="required">*</span></label>

          <textarea name="value" class="form-control" ng-model="value" ng-required="required" placeholder="{{ placeholder || '' }}"></textarea>
          <div ng-messages="form.value.$error" ng-if="form.$submitted">
            <div ng-message="required">This field is required</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn" ng-click="$dismiss()" data-dismiss="modal" ng-class="options.cancelBtnClass || 'btn-outline-primary'">
            {{ options.cancelBtnText || 'Cancel' }}
          </button><!-- do not delete --><button type="submit" class="btn" ng-class="options.okBtnClass || 'btn-primary'">
            {{ options.okBtnText || 'OK' }}
          </button>
        </div>
      </form>
   `);
  }]);
